import app from 'flarum/app';
import Page from 'flarum/components/Page';
import Button from 'flarum/components/Button';
import LinkButton from 'flarum/components/LinkButton';
import Placeholder from 'flarum/components/Placeholder';
import listItems from 'flarum/helpers/listItems';
import icon from 'flarum/helpers/icon';
import NewFormModal from '../modals/NewFormModal';
import PageContainer from '../components/PageContainer';
import LoadingIndicator from '../components/LoadingIndicator';
import FormListState from '../states/FormListState';
import FormSortDropdown from '../components/FormSortDropdown';
import submissionCount from '../utils/submissionCount';
import GlobalSettings from '../components/GlobalSettings';

/* global m */

const translationPrefix = 'kilowhat-formulaire.forum.form-index.';

const TABS = [
    {
        key: 'standalone',
        icon: 'fas fa-poll-h',
        route: 'formulaireFormIndex',
    },
    {
        key: 'discussion',
        icon: 'fas fa-comment-alt',
        route: 'formulaireFormIndexDiscussion',
    },
    {
        key: 'user',
        icon: 'fas fa-user-tag',
        route: 'formulaireFormIndexUser',
    },
];

export default class FormIndexPage extends Page {
    init() {
        super.init();

        switch (this.props.routeName) {
            case 'formulaireFormIndexDiscussion':
                this.formType = 'discussion';
                break;
            case 'formulaireFormIndexUser':
                this.formType = 'user';
                break;
            default:
                this.formType = 'standalone';
        }

        this.formList = new FormListState({
            q: 'type:' + this.formType,
        });
        this.formList.refresh();
    }

    view() {
        return PageContainer.component({}, [
            m('.FormulaireHeader.FormulaireHeader--banner', [
                icon('fas fa-poll-h', {
                    className: 'FormulaireBanner',
                }),
                m('h1', app.translator.trans(translationPrefix + 'header.' + 'title')),
                m('ul.FormulaireHeaderLinks', [
                    m('li', m('a', {
                        target: '_blank',
                        href: 'https://kilowhat.net/flarum/extensions/formulaire',
                    }, [
                        app.translator.trans(translationPrefix + 'header.' + 'documentation'),
                        ' ',
                        icon('fas fa-external-link-alt'),
                    ])),
                    m('li', m('a', {
                        target: '_blank',
                        href: 'https://discuss.flarum.org/d/23063',
                    }, [
                        app.translator.trans(translationPrefix + 'header.' + 'discuss'),
                        ' ',
                        icon('fas fa-external-link-alt'),
                    ])),
                ]),
                m('.FormulaireTabs', TABS.map(tab => LinkButton.component({
                    className: this.formType === tab.key ? 'active' : '',
                    icon: tab.icon,
                    route: app.route(tab.route),
                }, app.translator.trans(translationPrefix + 'tabs.' + tab.key)))),
            ]),
            GlobalSettings.component({
                type: this.formType,
            }),
            m('.FormulaireFilters', [
                m(FormSortDropdown, {
                    sort: this.formList.params.sort,
                    onchange: value => {
                        this.formList.params.sort = value;
                        this.formList.refresh();
                    },
                }),
                Button.component({
                    className: 'Button Button--primary',
                    icon: 'fas fa-plus',
                    onclick: () => {
                        app.modal.show(new NewFormModal({
                            oncreateordelete: () => {
                                this.refresh();
                            },
                            linkType: this.formType === 'discussion' ? 'tags' : (this.formType === 'user' ? 'groups' : null),
                        }));
                    },
                }, app.translator.trans(translationPrefix + 'new')),
            ]),
            this.list(this.formList),
        ]);
    }

    list(state) {
        let loading;

        if (state.loading) {
            loading = LoadingIndicator.component();
        } else if (state.moreResults) {
            loading = Button.component({
                className: 'Button',
                onclick: state.loadMore.bind(state),
            }, app.translator.trans(translationPrefix + 'load-more'));
        }

        if (state.forms.length === 0 && !state.loading) {
            return Placeholder.component({
                text: app.translator.trans(translationPrefix + 'empty'),
            });
        }

        return m('div', [
            m('table.FormulaireDataTable', [
                m('thead', m('tr', [
                    m('th', app.translator.trans(translationPrefix + 'columns.title')),
                    m('th', app.translator.trans(translationPrefix + 'columns.accept-submissions')),
                    m('th', app.translator.trans(translationPrefix + 'columns.allow-modification')),
                    m('th', app.translator.trans(translationPrefix + 'columns.submissions')),
                    m('th', app.translator.trans(translationPrefix + 'columns.actions')),
                ])),
                m('tbody', state.forms.map(form => {
                    const badges = form.badges().toArray();

                    return m('tr', [
                        m('td', [
                            form.private_title(),
                            badges.length ? m('ul.FormulaireDataTable-badges.badges', listItems(badges)) : null,
                        ]),
                        m('td', form.accept_submissions() ? icon('fas fa-check') : null),
                        m('td', form.allow_modification() ? icon('fas fa-check') : null),
                        m('td', submissionCount(form)),
                        m('td', [
                            LinkButton.component({
                                className: 'Button',
                                href: app.route.formulaireFormEdit(form),
                            }, app.translator.trans(translationPrefix + 'edit')),
                            ' ',
                            LinkButton.component({
                                className: 'Button',
                                href: app.route.formulaireFormShow(form),
                            }, app.translator.trans(translationPrefix + 'show')),
                            ' ',
                            LinkButton.component({
                                className: 'Button',
                                href: app.route.formulaireSubmissionIndex(form),
                            }, app.translator.trans(translationPrefix + 'submissions')),
                        ]),
                    ]);
                })),
            ]),
            loading,
        ]);
    }
}
